import React from 'react';
import Select, { defaultTheme } from 'react-select';
import CreatableSelect from 'react-select/creatable';

export default function InputSelect({
  // @ts-ignore
  value,
  options = [],
  onChange = (name: any) => {},
  styles = {},
  isDisabled = false,
  isMulti = false,
  isCreatable = false,
  isClearable = true,
  isSearchable = true,
  ...props
}) {
  const toOption = (rawValue: any) => {
    const matchedOption = options.find((option: any) => option?.value === rawValue);
    return {
      label: matchedOption?.label ?? String(rawValue),
      value: rawValue,
    };
  };

  let _value =
    value === undefined || value === null || value === '' ? null : toOption(value);

  if (isMulti) {
    // @ts-ignore
    _value = Array.isArray(value) ? value.map(toOption) : [];
  }
  // console.log(defaultTheme);
  // console.log(mergeStyles);

  const Component = isCreatable ? CreatableSelect : Select;

  return (
    <Component
      theme={{
        ...defaultTheme,
        colors: {
          ...defaultTheme.colors,
          primary: '#2D77A0',
          primary75: '#EDEDED',
          primary50: '#EDEDED',
          primary25: '#EDEDED',
          neutral20: '#C8CCE5',
          neutral30: '#9EA5D1',
          neutral50: '#A1A1AA',
          neutral80: '#3E4784',
        },
        borderRadius: 11,
        // @ts-ignore
        fontSize: '5px',
      }}
      isMulti={isMulti}
      value={_value}
      onChange={(res) => {
        if (isMulti && Array.isArray(res)) {
          onChange(res.map((o) => o.value));
          return;
        }

        if (res) {
          // @ts-ignore
          onChange(res.value);
        } else {
          onChange('');
        }
      }}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isSearchable={isSearchable}
      name="select"
      options={options}
      styles={{ ...styles }}
      {...props}
    />
  );
}
